<div class="profile-card" (click)="onProfileClick(profile)">
    <img class="rounded-circle light-shadow profile-card__profile-image" [src]="profilesService.getImageUrl(profile.profileImage)"
        (error)="profilesService.onImgError($event)" data-test="profile-card-image">
    <div class="profile-card__profile-name" data-test="profile-card-name">
        {{profile.displayName}}
    </div>
    <div class="profile-card__profile-badge-container profile-badge-container">
      <ng-container *ngIf="profile?.state===profileStates.PaymentRequired">
        <div  class="profile-badge-container__profile-badge badge profile-badge"
            [class.profile-badge--incomplete]="profile?.state===profileStates.PaymentRequired">
            {{('select-profile.states.' + profile.state)|translate}}
        </div>
      </ng-container>
      <div class="profile-card__profile-delete" *ngIf="canDelete" (click)="onDeleteClick($event)">
          <i class="fas fa-trash-alt"></i>
      </div>

    </div>
</div>
